'use client';
import React, { forwardRef } from 'react';
import 'clsx';
import '@mantine/hooks';
import '../../../core/MantineProvider/Mantine.context.mjs';
import '../../../core/MantineProvider/default-theme.mjs';
import '../../../core/MantineProvider/MantineProvider.mjs';
import '../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { Box } from '../../../core/Box/Box.mjs';
import '../../../core/DirectionProvider/DirectionProvider.mjs';

const Thumb = forwardRef(({ position, ...others }, ref) => /* @__PURE__ */ React.createElement(
  Box,
  {
    ref,
    __vars: {
      "--_thumb-y-offset": `${position.y * 100}%`,
      "--_thumb-x-offset": `${position.x * 100}%`
    },
    ...others
  }
));
Thumb.displayName = "@mantine/core/ColorPickerThumb";

export { Thumb };
//# sourceMappingURL=Thumb.mjs.map
